( function () {
    'use strict';
    /**
     * @namespace
     */
    master.formElements = {
        /** @function */
        /**
         * Get touchswipe vendor script
         * @async
         */
        getScript: function () {
            var that = this;
            jQuery.getScript( '//cdnjs.cloudflare.com/ajax/libs/jquery.touchswipe/1.6.18/jquery.touchSwipe.js', function () {
                that.swipeToggle();
            } );
        },
        /** @function */
        /**
         * Populate selectbox with workshops from sessionStorage
         */
        fillWorkshopSelect: function () {
            var jWorkSelect = jQuery( '.js-form-workshop-select' ),
                userManagementAddresses = JSON.parse( master.store.session.userManagementAddresses );
            jQuery.each( userManagementAddresses, function ( index, workshop ) {
                jWorkSelect.append( '<option value="' + workshop.Email + '">' + workshop.Name + '</option>' );
            } );
        },
        /**
         * @namespace
         * @property {integer} timeout
         * @property {integer} currentTimestamp
         */
        preserveForms: {
            timeout: master.settings.formPreservableTimeout,
            currentTimestamp: parseInt( Date.now() / 1000 ),
            /** @function */
            /**
             * Save form data to sessionStorage
             * @param {HtmlFormElement} jForm
             * @param {string} formID
             * @param {object} jPreservedFormData
             * @param {int} timestamp
             * @param {boolean} deletable
             */
            save: function ( jForm, formID, jPreservedFormData, timestamp, deletable ) {
                jForm.each( function () {
                    //var formData = jQuery.each( jQuery( this ).find( 'input' ).not( '[type="password"], [type="hidden"], .js-not-preservable' ).serializeArray(), function () {} );
                    var formArr = [];
                    jForm.find( 'input, textarea' ).not( '[type="password"], .js-not-preservable' ).each( function ( index ) {
                        var formObj = {};
                        formObj.name = jQuery( this ).attr( 'name' );
                        formObj.type = jQuery( this ).attr( 'type' );
                        formObj.value = jQuery( this ).val();
                        formObj.index = index;
                        if ( jQuery( this ).attr( 'type' ) === 'radio' || jQuery( this ).attr( 'type' ) === 'checkbox' ) {
                            formObj.checked = jQuery( this ).prop( 'checked' );
                        }
                        formArr.push( formObj );
                    } );
                    jPreservedFormData[ formID ] = {};
                    jPreservedFormData[ formID ] = formArr;
                    jPreservedFormData.timestamp = timestamp;
                    jPreservedFormData.deletable = deletable;
                    sessionStorage.setItem( 'preservedFormData', JSON.stringify( jPreservedFormData ) );
                } );
            },
            /** @function */
            /**
             * Load form data to sessionStorage
             * @param {HtmlFormElement} jForm
             * @param {string} formID
             * @param {object} jPreservedFormData
             */
            load: function ( jForm, formID, jPreservedFormData ) {
                var jFormFields = jPreservedFormData[ formID ];
                if ( jFormFields !== undefined ) {
                    for ( var i = 0; i < jFormFields.length; i++ ) {
                        if ( jFormFields[ i ].type === 'text' || jFormFields[ i ].type === 'number' || jFormFields[ i ].type === 'hidden' || jFormFields[ i ].type === 'textarea' ) {
                            jForm.find( '[name="' + jFormFields[ i ].name + '"]' ).val( jFormFields[ i ].value ).trigger( 'change' );
                        }
                        if ( jFormFields[ i ].type === 'radio' || jFormFields[ i ].type === 'checkbox' ) {
                            if ( jFormFields[ i ].checked === true ) {
                                jForm.find( '[name="' + jFormFields[ i ].name + '"]' ).prop( 'checked', true ).trigger( 'change' );
                            }
                        }
                    }
                }
            },
            init: function () {
                var that = this,
                    jPreservedFormData = JSON.parse( sessionStorage.getItem( 'preservedFormData' ) ) || {},
                    jForm = jQuery( '.js-preserve-data-form' ),
                    jFieldset = jQuery( '.js-preserve-data-fieldset' );
                if ( jForm.length ) {
                    that.load( jForm, jForm.attr( 'id' ), jPreservedFormData );
                }
                else if ( jFieldset.length ) {
                    that.load( jFieldset.parents( 'form' ), jFieldset.attr( 'id' ), jPreservedFormData );
                }
                espresso.constant.jWindow.on( 'beforeunload', function () {
                    var timestamp = that.currentTimestamp,
                        jForm = jQuery( '.js-preserve-data-form' ),
                        jFieldset = jQuery( '.js-preserve-data-fieldset' );
                    if ( jForm.length ) {
                        that.save( jForm, jForm.attr( 'id' ), jPreservedFormData, timestamp, jForm.data( 'deletable' ) );
                    }
                    else if ( jFieldset.length ) {
                        that.save( jFieldset.parents( 'form' ), jFieldset.attr( 'id' ), jPreservedFormData, timestamp, jFieldset.data( 'deletable' ) );
                    }
                    else if ( jPreservedFormData.timestamp !== undefined && jPreservedFormData.deletable === true ) {
                        if ( Math.abs( timestamp - jPreservedFormData.timestamp ) > that.timeout ) {
                            sessionStorage.removeItem( 'preservedFormData' );
                        }
                    }
                } );
            }
        },
        /** @function */
        /**
         * Toggle for custom checkbox
         */
        toggle: function () {
            jQuery( '.js-checkbox-toggle' ).on( 'click', function () {
                var jToggle = jQuery( this ),
                    jToggleBox = jToggle.parents( '.js-checkbox-toggle-box' );
                if ( jToggleBox.length ) {
                    var disableID = jQuery( this ).data( 'disabled-id' );
                    if ( disableID ) {
                        if ( jQuery( this ).is( ':checked' ) !== true && jQuery( 'fieldset[data-disabled-id="' + disableID + '"]' ).data( 'clear' ) === true ) {
                            event.preventDefault();
                            event.stopPropagation();
                            jQuery( '.js-workshop-administration-social-modal' ).modal( 'show' );
                        }
                        else {
                            var jToggleOnText = jToggleBox.data( 'toggle-on' ),
                                jToggleOffText = jToggleBox.data( 'toggle-off' );
                            if ( jQuery( this ).is( ':checked' ) === true ) {
                                jToggleBox.removeClass( ' toggle-off' ).addClass( 'toggle-on' );
                            }
                            else {
                                jToggleBox.removeClass( ' toggle-on' ).addClass( 'toggle-off' );
                            }
                            jToggleBox.find( '.js-toggle-text' ).text( function () {
                                return jToggle.is( ':checked' ) ? jToggleOnText : jToggleOffText;
                            } );
                        }
                    }
                }
            } );
        },
        /** @function */
        /**
         * Toggle checkbox by swipe
         */
        swipeToggle: function () {
            jQuery( '.js-checkbox-toggle' ).next( 'label' ).swipe( {
                swipeLeft: function () {
                    jQuery( this ).prev( '.js-checkbox-toggle' ).prop( 'checked', false ).trigger( 'change' );
                },
                swipeRight: function () {
                    jQuery( this ).prev( '.js-checkbox-toggle' ).prop( 'checked', true ).trigger( 'change' );
                }
            } );
        },
        /** @function */
        /**
         * Disable element when changing checkbox
         */
        boolean: function () {
            jQuery( '.js-checkbox-boolean' ).on( 'change', function () {
                var disableID = jQuery( this ).data( 'disabled-id' ),
                    boolClear = jQuery( 'fieldset[data-disabled-id="' + disableID + '"]' ).data( 'clear' );
                if ( jQuery( this ).is( ':checked' ) === true ) {
                    jQuery( this ).parent().find( '.js-hidden-boolean' ).val( 'True' );
                    if ( disableID ) {
                        if ( boolClear === undefined ) {
                            jQuery( 'fieldset[data-disabled-id="' + disableID + '"]' ).prop( 'disabled', false );
                        }
                        else {
                            jQuery( 'fieldset[data-disabled-id="' + disableID + '"]' ).removeClass( 'disabled' );
                            if ( jQuery( 'fieldset[data-disabled-id="' + disableID + '"]' ).data( 'clear' ) === false ) {
                                jQuery( 'fieldset[data-disabled-id="' + disableID + '"]' ).data( 'clear', true );
                            }
                        }
                    }
                }
                else {
                    jQuery( this ).parent().find( '.js-hidden-boolean' ).val( 'False' );
                    if ( disableID ) {
                        if ( boolClear === undefined ) {
                            jQuery( 'fieldset[data-disabled-id="' + disableID + '"]' ).prop( 'disabled', true );
                        }
                        else {
                            jQuery( 'fieldset[data-disabled-id="' + disableID + '"]' ).addClass( 'disabled' );
                        }
                    }
                }
            } ).trigger( 'change' );
            /*
            jQuery( '.js-checkbox-boolean' ).on( 'click', function ( event ) {
                var disableID = jQuery( this ).data( 'disabled-id' );
                if ( disableID ) {
                    if ( jQuery( this ).is( ':checked' ) !== true && jQuery( 'fieldset[data-disabled-id="' + disableID + '"]' ).data( 'clear' ) === true ) {
                        event.preventDefault();
                        event.stopPropagation();
                        jQuery( '.js-workshop-administration-social-modal' ).modal( 'show' );
                    }
                }
            } );
            */
        },
        init: function () {
            this.fillWorkshopSelect();
            this.boolean();
            this.toggle();
            if ( jQuery( '.js-checkbox-toggle' ).length && master.utils.isMobile( navigator.userAgent || navigator.vendor || window.opera ) && espresso.constant.jWindow.width() < 768 ) {
                this.getScript();
            }
            jQuery( '[data-link]' ).on( 'click', function () {
                var href = jQuery( this ).data( 'link' );
                window.open( href );
            } );
            setTimeout( function () {
                master.formElements.preserveForms.init();
            }, 500 );
        }
    };
}() );
